import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function JarIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 60" {...props}>
      <title>Jar</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0372 11.8512H48.3349V9.53721C48.3349 7.01906 46.2931 5 43.7977 5H16.5744C14.0563 5 12.0372 7.04174 12.0372 9.53721V11.8512ZM12.0372 14.1878H48.3349C50.8303 14.1878 52.8721 16.6606 52.8721 19.7232V49.4873C52.8721 52.5272 50.853 55 48.3349 55H12.0372C9.54174 55 7.5 52.5272 7.5 49.4873V19.7005C7.5 16.6606 9.51906 14.1878 12.0372 14.1878ZM29.7777 30.9301H37.6951V26.1207H22.677V43.1125H29.7777V37.872H35.1997V34.1515H29.7777V30.9301Z"
        />
      </g>
    </SvgIcon>
  );
}

export default JarIcon;
